<template>
  <e-chart
    :header="`${documentTitle}`"
    :options="chartProductionGarbageOptions"
    :series="chartCalculationGarbageSeries"
    class="item-large"
    chartId="garbageCalculation"
    :chartRedirectParams="chartRedirectParams"
    :chartLoading="chartLoading"
    :chartError="chartError"
    :alwaysDisableAnimation="true"
  >
    <template slot="exportData">
      <div class="chart-block__export-data">
        <div>{{ documentTitle }}</div>
        <div>
          Показатель:
          {{
            chartViewGarbageType.find(
              (item) => item.id === fields.garbageCalculation.viewMode
            ).name
          }}
        </div>
        <div>Период: {{ fields.garbageProductionYear }}</div>
      </div>
    </template>
    <template slot="chartHeader">
      <div class="default-select part-1-from-1 chart-block__wide-select">
        <e-select
          @change="fetchData"
          tabView="tab1"
          :model="fields.garbageCalculation"
          name="viewMode"
          :options="chartViewGarbageType"
        ></e-select>
      </div>
      <div class="default-select part-1-from-4">
        <e-select
          @change="fetchData"
          tabView="tab1"
          :model="fields"
          name="garbageProductionYear"
          :options="chartYearOptions"
        ></e-select>
      </div>
    </template>
  </e-chart>
</template>
<script>
import chartsMixin from '../mixins/charts-mixin'

export default {
  name: 'chart-garbage-calculation',
  mixins: [chartsMixin],
  props: { limit: { type: Number, default: null } },
  computed: {
    viewMode: {
      get: function () {
        return this.$store.getters.charts.garbageCalculation.viewMode
      },
      set: function (newValue) {
        this.$store.commit('charts', {
          garbageCalculation: { viewMode: newValue },
        })
      },
    },
    getCurrentChartOptions() {
      return this.getChartOptions('garbageCalculation')
    },
  },
  methods: {
    buildEndpoint() {
      return this.getEndpoint()({
        query: {
          type: 'sumfkko',
          year: this.fields.garbageProductionYear,
          viewMode: this.fields.garbageCalculation.viewMode,
        },
      })
    },
    fetchData() {
      this.fetchChartData().then((r) => {
        this.chartCalculationGarbageSeries = this.transform(r)
        this.createAndSetCats(r, this.chartCalculationGarbageSeries)
      })
    },
    createAndSetCats(r, series = []) {
      let cats = []
      let indexForPosition = 0
      let positions = []
      series[0].data.forEach((v) => {
        cats.push(`${v.name}`)
        positions.push(indexForPosition)
        indexForPosition++
      })
      let options = Object.assign({}, this.chartProductionGarbageOptions)
      options.xAxis.categories = cats
      options.xAxis.tickPositions = positions
      options.xAxis.max = this.limit
      this.chartProductionGarbageOptions = Object.assign({}, options)
    },
  },
  created() {
    this.chartProductionGarbageOptions = this.getCurrentChartOptions
    this.fetchData()
  },
}
</script>
